// src/pages/auth/LoginPage.jsx
import React from 'react';
import LoginForm from '../../components/forms/LoginForm';

const LoginPage = () => {
  return <LoginForm />;
};

export default LoginPage;